import {DocumentType} from "../../domain/verification/DocumentType";
import {useEffect, useState} from "react";
import {VerifyService} from "../../service/VerifyService";

interface RetrieveDocumentTypeViewModelReturn {
    loading: boolean
    documentType: DocumentType | undefined
    twoSided: boolean
}

export const RetrieveDocumentTypeViewModel = (verificationId: string | undefined): RetrieveDocumentTypeViewModelReturn => {

    const [loading, setLoading] = useState<boolean>(false);
    const [documentType, setDocumentType] = useState<DocumentType>()
    const [twoSided, setTwoSided] = useState<boolean>(false)

    useEffect(() => {
        if (verificationId) {
            retrieveDocumentType(verificationId)
        }
    }, [verificationId])

    const retrieveDocumentType = async (verificationId: string) => {
        const service = VerifyService.getInstance()
        setLoading(true)
        const response = await service.getDocumentType(verificationId)
        setDocumentType(response.documentType)
        setTwoSided(response.twoSided)
        setLoading(false)
    }

    return {
        loading,
        documentType,
        twoSided
    }

}